import noTokenRequest from '@/utils/request/noTokenRequest'

export function update_user(data) {
    return noTokenRequest({
        url: '/console/update_user',
        method: 'post',
        data
    });
}
export function create_courseware_user(data) {
    return noTokenRequest({
        url: '/console/create_courseware_user',
        method: 'post',
        data
    });
}
export function query_plan_and_download_link(data) {
    return noTokenRequest({
        url: '/console/query_plan_and_download_link',
        method: 'post',
        data
    })
}
export function query_courseware_by_set_id(data) {
    return noTokenRequest({
        url: '/console/query_courseware_by_set_id',
        method: 'post',
        data
    });
}
export function query_courseware_by_subject_id(data) {
    return noTokenRequest({
        url: '/console/query_courseware_by_subject_id',
        method: 'post',
        data
    });
}


export function get_class_by_user_id(data) {
    return noTokenRequest({
        url: '/console/get_class_by_user_id',
        method: 'post',
        data
    })
}
export function get_subject_by_user_id(data) {
    return noTokenRequest({
        url: '/console/get_subject_by_user_id',
        method: 'post',
        data
    })
}
export function get_edition_and_textbook_by_subject_and_class(data) {
    return noTokenRequest({
        url: '/console/get_edition_and_textbook_by_subject_and_class',
        method: 'post',
        data
    })
}
export function query_catalog_by_textbook_id(data) {
    return noTokenRequest({
        url: '/console/query_catalog_by_textbook_id',
        method: 'post',
        data
    })
}
export function set_stop_time(data) {
    return noTokenRequest({
        url: '/console/set_stop_time',
        method: 'post',
        data
    })
}
export function get_stop_time(data) {
    return noTokenRequest({
        url: '/console/get_stop_time',
        method: 'post',
        data
    })
}
export function get_plan_by_user_id(data) {
    return noTokenRequest({
        url: '/console/get_plan_by_user_id',
        method: 'post',
        data
    })
}
export function query_class_by_room_id(data) {
    return noTokenRequest({
        url: '/console/query_class_by_room_id',
        method: 'post',
        data
    })
}
export function update_class_time(data) {
    return noTokenRequest({
        url: '/console/update_class_time',
        method: 'post',
        data
    })
}
export function delete_class_time(data) {
    return noTokenRequest({
        url: '/console/delete_class_time',
        method: 'post',
        data
    })
}
// 删除pad题集学生答题记录(2026-10-29): 按plan_id清t_plan_join_detaill全部学生作答
export function delete_pad_answer_records(data) {
    return noTokenRequest({
        url: '/console/delete_pad_answer_records',
        method: 'post',
        data
    })
}
export function query_plan_version(data) {
    return noTokenRequest({
        url: '/console/query_plan_version',
        method: 'post',
        data
    })
}
export function continue_class_time(data) {
    return noTokenRequest({
        url: '/console/continue_class_time',
        method: 'post',
        data
    })
}
export function get_question_reading_materials(data) {
    return noTokenRequest({
        url: '/console/get_question_reading_materials',
        method: 'post',
        data
    })
}
export function save_class_star_settings(data) {
    return noTokenRequest({
        url: '/console/save_class_star_settings',
        method: 'post',
        data
    })
}
export function get_class_star_settings(data) {
    return noTokenRequest({
        url: '/console/get_class_star_settings',
        method: 'post',
        data
    })
}
export function query_plan_time_by_room_id_class_id_plan_id(data) {
    return noTokenRequest({
        url: '/console/query_plan_time_by_room_id_class_id_plan_id',
        method: 'post',
        data
    })
}
export function get_server_time(data) {
    return noTokenRequest({
        url: '/console/get_server_time',
        method: 'post',
        data
    })
}
export function delayed_class_time(data) {
    return noTokenRequest({
        url: '/console/delayed_class_time',
        method: 'post',
        data
    })
}

export function update_conflict_class_time(data) {
    return noTokenRequest({
        url: '/console/update_conflict_class_time',
        method: 'post',
        data
    })
}
export function query_question_set_id_by_plan_id(data) {
    return noTokenRequest({
        url: '/console/query_question_set_id_by_plan_id',
        method: 'post',
        data
    })
}
export function get_set_info_by_set_id(data) {
    return noTokenRequest({
        url: '/console/get_set_info_by_set_id',
        method: 'post',
        data
    })
}
export function get_question_list_by_set_id(data) {
    return noTokenRequest({
        url: '/console/get_question_list_by_set_id',
        method: 'post',
        data
    })
}
